<template>
  <div>
    <div class="picBox">
      <div class="title">
        <img
          src="../../assets/zhaopian.png"
          style="margin-right: 10px"
        />
        演练照片
      </div>
      <router-link
        class="morePic"
        :to="{
          path: '/morePic',
        }"
        >更多></router-link>
    </div>
    <div class="picContainer" v-if="picture.length>0">
      <div class="picItem" v-for="item in this.picture.slice(0,6)" :key="item.id" @click="viewPic(item.pictureUrl)">
        <img :src="item.pictureUrl" :onerror="defaultImg" style="width: 100%; height: 100%" />
        <span class="topbox" v-if="item.sortNo==1">置顶</span>
      </div>
    </div>
    <div class="picContainer" v-else>
      <div class="picItem" @click="viewPic(defIMG)">
        <img :src="defIMG" :onerror="defaultImg" style="width: 100%; height: 100%" />
        <span class="topbox">置顶</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'ant-design-vue';
export default {
  name: "Picture",
  data() {
    return {
      defIMG: window.network['domianBase'] + '/xiaofang-static/temp/QQ截图20211020151117_1634713826413.png',
      defaultImg: 'this.src="' + require("../../assets/loading.png") + '"'
    }
  },
  props: {
    picture: Array,
  },
  methods: {
    viewPic(urlx) {
      this.$success({
        content: (
          <img
            ref="cerimg"
            class="cerimg"
            src={urlx}
            alt
            style="max-width: 98vw; max-height: 60vh;"
          />
        ),
        closeIcon: 'close-circle',
        closable: true,
        class: "vpClass",
        maskClosable: true,
        autoFocusButton: null,
        okText: "",
        maskStyle:{background:'#000000'},
      });
    },
  },
};
</script>

<style scoped>
.picBox {
  display: flex;
  justify-content: space-between;
}
.title {
  margin-top: 3vh;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 1vw;
  height: 3vh;
  font-size: 18px;
  display: flex;
  align-items: flex-end;
}
@media screen and (min-width: 768px) {
  .title {
  margin-top: 94px;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 1vw;
  height: 3vh;
  font-size: 31px;
  display: flex;
  align-items: flex-end;
}
}
@media screen and (min-width: 768px) {
  .title img{
    width: 36px;
    height: auto;
    margin-right: 10px;
    position: relative;
    top: -4px;
}
}
@media screen and (max-width: 768px) {
  .title img{
    width: 22px;
    height: auto;
    margin-right: 10px;
    position: relative;
    top: -3px;
}
}
@media screen and (max-width: 768px) {
.morePic {
  font-size: 15px;
  color: #999999;
  line-height: 56px;
  padding-right: 1vw;
}
}
@media screen and (min-width: 768px) {
.morePic {
  font-size: 15px;
  color: #999999;
  padding-right: 1vw;
  margin-top: 13.5%;
}
}
@media screen and (min-width: 768px) {
.picContainer {
  padding: 20px 1vw  64px;
  display: flex;
  flex-wrap: wrap;
}
}
@media screen and (max-width: 768px) {
.picContainer {
  padding: 1vw;
  display: flex;
  flex-wrap: wrap;
}
}
@media screen and (min-width: 768px) {
.picItem {
  position: relative;
  width: 30%;
  height: 18vh;
  margin-bottom: 15px;
  border-radius: 1vw;
  margin-right: 15px;
  cursor: pointer;
}
}
@media screen and (max-width: 768px) {
  .picItem {
    position: relative;
    width: 30%;
    height: 11vh;
    border-radius: 1vw;
    margin-bottom: 4px;
    margin-right: 11px;
  }
}
.topbox {
  position: absolute;
  z-index: 10;
  display: inline-block;
  width: 30px;
  height: 20px;
  line-height: 20px;
  top: 0;
  right: 0;
  color: #fff;
  background: #fa3261;
  font-size: 13px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Picture/Picture.vue